import React, { useContext } from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { color } from 'styles/pallete';
import { AccordionNavbarProps } from 'types/AccordionNavbarProps';
import { getObjOnLocalStorage, searchValueInArray } from 'utils/functions';
import { UserProps } from 'types/UserProps';
import { SubOptionsNavbar } from 'types/SubOptionsNavbar';
import { ItemNav } from 'types/itemNavBar';
import WindowSize from 'types/WindowSize';
import useWindowSize from 'hooks/useWindowSize';
import NavBarContext from 'context/NavBarContext';
import { UseTranslationProps } from 'types/UseTranslationProps';

// ESTE ACCORDION FOI CRIADO POR QUE TINHA MUITAS ESPECIFIDADES QUE SERIAM USADAS SOMENTE NA NAVBAR
export default function AccordionNavbar({
	children,
	title = 'Título',
	isSubOptions = false,
	arraySubtitles,
	optionIsALink = false,
	slug = '/',
	needTranslationSuboptions = false,
	typeUserArray,
	pathIconAccordion,
	isExternaLink,
	isOpenAccordion,
	idAccordion,
	finalDateTagNew,
	tagNew
}: AccordionNavbarProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { listNavBar, setListNavBar, setIsOpen } = useContext(NavBarContext);
	const { width }: WindowSize = useWindowSize();

	// Propriedades do DataLoginType podem ser indefinidas, por que se a pessoa não tiver logada pode ocorrer erro. Por isso estou setando valores iniciais.
	let typeUser = 1;
	let userHasAcess = true;
	let nameStore = '';

	// se não houver dados de login, o role continuara como 10 só para não bugar
	const userData: UserProps = getObjOnLocalStorage();

	if (userData) {
		typeUser = 0;
		userHasAcess = searchValueInArray(typeUser, typeUserArray);
		nameStore = 'Mondelez Estático';
	}

	function selectSubOption(value: SubOptionsNavbar) {
		const listNavBarCopy: ItemNav[] = structuredClone(listNavBar);
		const newList = listNavBarCopy.map((item) => {
			if (item.isSubOptions && item.subOptions !== undefined) {
				item.subOptions.forEach((itemSubOption) => {
					if (itemSubOption.name === value.name) {
						itemSubOption.isSelected = true;
					} else {
						itemSubOption.isSelected = false;
					}
				});
			}
			return item;
		});

		setTimeout(() => setListNavBar(newList), 1);
	}

	function closeNavBarWhenInMobileMode() {
		if (width! < 1000) {
			setTimeout(() => {
				setIsOpen(false);
			}, 1);
		}
	}

	function toogleOptionNavBar(id: number) {
		const listNavBarCopy = structuredClone(listNavBar);
		const newList = listNavBarCopy.map((item: ItemNav) => {
			if (item.id === id) {
				item.isOpen = !item.isOpen;
			} else {
				item.isOpen = false;
			}
			if (item.isSubOptions && item.subOptions !== undefined) {
				item.subOptions.forEach((subItem: SubOptionsNavbar) => {
					subItem.isSelected = false;
				});
			}
			return item;
		});

		setTimeout(() => setListNavBar(newList), 1); // coloquei dentro de settimeout (tempo minimo imperceptivel) para nao dar erro no redux
	}

	function returnTagNew(show: boolean, finalDate: string | null) {
		const today = new Date();
		const finalDateFormated = finalDate === null ? null : new Date(finalDate);

		if (!show) {
			return <></>;
		}

		if (finalDateFormated === null) {
			return <></>;
		}

		if (finalDateFormated < today) {
			return <></>;
		}

		if (show && finalDateFormated > today)
			return (
				<S.tagNew>
					<p>{t('new')}</p>
				</S.tagNew>
			);
	}

	return (
		<S.container $isShowAccordion={userHasAcess}>
			{/* antes de retornar o item, preciso verificar se o usuário tem acesso */}
			{userHasAcess !== undefined && (
				<S.title
					onClick={() => toogleOptionNavBar(idAccordion)}
					$isSelect={isOpenAccordion}
				>
					<S.iconAccordion src={pathIconAccordion} />

					{/* Quando o item do navbar não tem subitem */}
					{optionIsALink && isSubOptions ? (
						<p>{title}</p>
					) : (
						<>
							{isExternaLink ? (
								<a href={`https://${nameStore}v2.mobfiq.com.br/${slug}`}>
									<p>{needTranslationSuboptions ? t(title) : title}</p>
								</a>
							) : (
								<Link to={slug} onClick={closeNavBarWhenInMobileMode}>
									<p>{title}</p>
									{returnTagNew(tagNew, finalDateTagNew)}
								</Link>
							)}
						</>
					)}

					{/* quando tem subitens é colocado um ícone para mostrar que há mais opções */}
					{isSubOptions && (
						<S.arrow>
							<MdKeyboardArrowRight
								style={{
									color: color.interface.darkgray2,
									fontSize: '20px',
									cursor: 'pointer',
									transition: 'all ease .5s',
									transform: isOpenAccordion ? 'rotate(90deg)' : 'rotate(0deg)'
								}}
							/>
						</S.arrow>
					)}
				</S.title>
			)}

			{/* Aqui são listado as subopções do navbar quando elas existem */}
			{userHasAcess !== undefined &&
				isSubOptions &&
				arraySubtitles &&
				arraySubtitles.length > 0 && (
					<S.contentAccordion $isOpen={isOpenAccordion}>
						{arraySubtitles.map(
							(item) =>
								// antes de retornar o subitem, preciso verificar se o usuário tem acesso
								searchValueInArray(typeUser, item.roleSubitem) !==
									undefined && (
									<S.containerSuboption
										key={item.name}
										$isSelected={item.isSelected}
										onClick={closeNavBarWhenInMobileMode}
									>
										{optionIsALink ? (
											<>
												<S.itemLink>
													{item.isExternaSublLink ? (
														<a
															href={`https://${nameStore}v2.mobfiq.com.br/${item.slug}`}
														>
															<p>
																{needTranslationSuboptions
																	? t(item.name)
																	: item.name}
															</p>
														</a>
													) : (
														<Link
															to={item.slug}
															onClick={() => selectSubOption(item)}
														>
															<p>
																{needTranslationSuboptions
																	? t(item.name)
																	: item.name}
															</p>
														</Link>
													)}

													{returnTagNew(item.tagNew, item.finalDateTagNew)}
												</S.itemLink>
											</>
										) : (
											<p>{item.name}</p>
										)}
									</S.containerSuboption>
								)
						)}
					</S.contentAccordion>
				)}

			{children && !isSubOptions && (
				<S.contentAccordion $isOpen={isOpenAccordion}>
					{children}
				</S.contentAccordion>
			)}
		</S.container>
	);
}
